<template>
  <div>
    <!-- 活动标题 -->
    <div v-wechat-title="'劳动节-首页'"></div>

    <div class="home-wrapper">
      <div class="hidden-box ignore-a"></div>
      <div class="home-page" id="home-page">
        <div class="main">
          <div class="container">
            <div class="content-box">
              <!-- 参与活动按钮 -->
              <a href="javascript:;" class="join-btn">
                <img src="../../../../assets/images/active/tideng/springFestival/cook/start.png" class="img-start" alt="参与活动" />
              </a>
              <!-- 剩余次数 -->
              <div class="left-times-box">入场券剩余: {{ activeInfo.times || 0 }}</div>
              <!-- 彩蛋 -->
              <div class="big-title"></div>
              <!-- 获取更多 -->
              <div class="btn-mission"></div>
              <!-- 练习模式 -->
              <div class="btn-game-test"></div>
              <!-- 设置 -->
              <div class="btn-setting-box" @click="openLoginOS()">
                <img src="../../../../assets/images/active/tideng/springFestival/cook/btn-setting.png" alt="设置" />
              </div>
              <div class="userInfo-box" v-if="userInfo.role_id">
                <div>账号: {{ userInfo.role_name }}</div>
                <div>区服: {{ userInfo.server_name }}</div>
                <div>总积分: {{ activeInfo.total_score || 0 }}分</div>
              </div>
              <!-- 菜单 -->
              <div class="btn-menu-box">
                <img src="../../../../assets/images/active/tideng/springFestival/cook/btn-menu.png" alt="菜单" />
              </div>
            </div>
          </div>
        </div>

        <!-- loading -->
        <div class="preloading_box" ref="preloading">
          <div class="loding_time">
            <div class="progress">
              <span ref="progress"></span>
              <div>请开启横屏模式参与体验哦~</div>
            </div>
          </div>
          <div class="bg"></div>
        </div>
      </div>
      <!-- 登陆模块 -->
      <Login v-if="isShowLogin"
        v-on:channelCallback="selectCallback"
        gameName="tideng"
        downloadUrl="https://static.qcplay.com/tideng/official/"
        channelTips="UID可在游戏中—设置—UID查看"></Login>
      <Os
        v-if="isShowOs"
        v-on:selectCallback="selectCallback"
        v-on:logoutCallback="osCancell"
        gameName="tideng"></Os>
    </div>
  </div>
</template>
<script>
import Clipboard from 'clipboard';
import Os from '@/components/os';
import Login from '@/components/login';
import { mapState, mapMutations, mapActions } from 'vuex';
import { onGetInitDataAPI } from '../api';
import { getRandomString, buriedLogger } from '@/utils/utils';
import { generateQRCode, generateCanvasImage } from '@/utils/share';

export default {
  name: 'laborDay',
  components: {
    Login,
    Os
  },
  data () {
    return {};
  },
  created () {
    // 清空store上的用户数据
    this.setInitActiveInfo();
    this.setInitUserInfo();

    // TODO:分享图测试
    this.$nextTick(() => {
      this.initShareData({ user_id: 10 });
    });

    // 埋点
    this.bl = buriedLogger('tideng', '提灯_春节');
    this.bl.sum('springFestival_home');
  },
  mounted () {
    this.$nextTick(() => {
      this.forceLandscapeScreenHandle();
      this.onWindowSizeChanged();
      this.startLoading();
    });
  },
  computed: {
    ...mapState([
      'userInfo',
      'activeInfo',
      'isShowLogin',
      'isShowOs'
    ])
  },
  watch: {
    userInfo: {
      handler (newValue, oldValue) {
        console.log('newValue', newValue);
        console.log('oldValue', oldValue);
        if (!newValue.user_id) {
          // TAG: 注销的时候
        } else if (newValue.user_id !== oldValue.user_id) {
          // TAG: 初始登陆/切换角色的时候
          const { protocol, host } = window.location;
          this.shareLink = `${protocol}//${host}/tideng/springFestival/help${getRandomString()}`;
          this.initShareData(newValue);
        }
      }
    }
  },
  methods: {
    // 适配
    forceLandscapeScreenHandle () {
      if (document.activeElement.nodeName === 'INPUT') return; // 兼容安卓
      const width = document.documentElement.clientWidth;
      const height = document.documentElement.clientHeight;

      // alert(document.documentElement.clientWidth)
      // alert(document.body.clientWidth)
      // alert(window.screen.availWidth)
      // const el = document.getElementById('app')
      const el = document.getElementById('home-page');
      const el1 = document.getElementById('share-page');
      let style = '';
      if (width < height) {
        style = `transform:rotate(90deg);transform-origin:${width / 2}px center;width:${height}px;height:${width}px`;
      } else {
        style = `transform:rotate(0deg);transform-origin:${width / 3}px center;width:${width}px;height:${height}px`;
      }
      if (el) el.style = style;
      if (el1) el1.style = style;

      // body
    },
    onWindowSizeChanged () {
      window.addEventListener('resize', this.forceLandscapeScreenHandle);
    },
    isReloadWindow (event) {
      return (
        !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) &&
        ((event && event.persisted) ||
          (window.performance && window.performance.navigation && window.performance.navigation.type === 2))
      );
    },
    startLoading () {
      // 防止第二次进入 微信底部有一个返回条，造成布局问题
      if (this.isReloadWindow()) {
        window.location.reload();
        return;
      }
      let progress = 5;
      this.timer = setInterval(() => {
        if (progress >= 95) {
          clearTimeout(this.timer);
          this.$refs.preloading.style.display = 'none';
          this.getLoginContainer();
          return;
        }
        progress = progress + 5;
        this.$refs.progress.setAttribute('style', 'width:' + progress + '%');
      }, 100);
    },
    selectCallback () {
      this.getLoginContainer();
    },
    osCancell () {
      this.getLoginContainer();
    },
    getLoginContainer () {
      onGetInitDataAPI().then(response => {
        // this.onInitDataCallback(response);
      });
    },
    initShareData (info) {
      try {
        this.setShare({ link: this.shareLink });
        this.qrcode(`${this.helpUrl}?id=${info.user_id}`);
        this.$nextTick(() => {
          this.generateShareImage();
        });
        // 例如：获取好友助力信息等
      } catch (err) {
        // 错误信息
        console.log('err', err);
      }
    },
    qrcode (link) {
      generateQRCode(document.getElementById('qrcode'), {
        text: link,
        colorDark: '#b8957e',
        colorLight: '#f3eadb'
      });
    },
    // 分享图片设置
    generateShareImage () {
      generateCanvasImage(this.$refs.imageDom)
        .then((canvas) => {
          this.shareImg = canvas.toDataURL('image/png'); // 可将 canvas 转为 base64 格式
          console.log('success: 图片生成成功');
        })
        .catch((err) => {
          console.log('err: 图片生成失败', err.message);
        });
    },
    // 复制链接
    onCopy () {
      const clipboard = new Clipboard('#clipboard-btn');
      clipboard.on('success', (e) => {
        this.onToast('复制成功');
        e.clearSelection();
      });
      clipboard.on('error', (e) => {
        this.onToast('复制失败');
      });
      this.bl.sum('springFestival_copy_link');
    },
    // TODO: 登陆弹窗demo
    openLoginOS () {
      if (this.userInfo.role_id) {
        this.changeOsPopup(true);
      } else {
        this.changeLoginPopup(true);
      }
    },
    ...mapMutations([
      'setUserInfo',
      'setInitUserInfo',
      'setInitActiveInfo',
      'changeLoginPopup',
      'changeOsPopup'
    ]),
    ...mapActions([
      'onInitDataCallback',
      'setShare'
    ])

  }
};
</script>

<style lang="less">
  @import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/tideng/springFestival/index/index.vue